export default __webpack_public_path__ + "static/media/logo_v1_icon_bw.30811af3.svg";